/* eslint-disable max-len */
import { isGettyClient } from '@helpers/getty-strings';
import { EmptyStateContent, FilterValues, PeoplePageParamKeys, SortValues } from './customPeopleTagTypes';
import { msg } from '@lingui/macro';

export const PER_PAGE_COUNT = 150;

export const filterByOptions = (): { key: FilterValues; label: string }[] => ([
  { key: FilterValues.All, label: 'All' },
  { key: FilterValues.Tagged, label: 'Tagged' },
  { key: FilterValues.Untagged, label: 'Untagged' },
]);

export const sortByOptions = (): { key: SortValues; label: string }[] => ([
  { key: SortValues.Newest, label: 'Upload date (newest)' },
  { key: SortValues.Oldest, label: 'Upload date (oldest)' },
  { key: SortValues.Most, label: 'Frequency (appears most)' },
  { key: SortValues.Least, label: 'Frequency (appears least)' },
  { key: SortValues.Ascending, label: 'Name (A-Z)' },
  { key: SortValues.Descending, label: 'Name (Z-A)' },
]);

export const libraryTitle = isGettyClient() ? 'Library' : 'Brandfolder';

export const emptyStates: EmptyStateContent = {
  [FilterValues.All]: {
    heading: msg`Gathering people from your photos...`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/s5h36khcc9n499bn2fkhcm/people.svg?auto=webp&format=svg',
    subheading: msg`People who are in this ${libraryTitle}’s photos will appear here. Check back soon to view and tag these people.`,
  },
  [PeoplePageParamKeys.Search]: {
    heading: msg`No results found`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/khsnqnp7k75jmt9qpvf2zhv/ghosts.svg?auto=webp&format=svg',
    subheading: msg`We couldn’t find a person with this name. They may not have been tagged yet, or if you recently uploaded assets, the photos may not have been processed for tagging.`,
  },
  [PeoplePageParamKeys.AssetIds]: {
    heading: msg`No results found`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/khsnqnp7k75jmt9qpvf2zhv/ghosts.svg?auto=webp&format=svg',
    subheading: msg`We couldn’t find the people in these assets. If you recently uploaded assets, the photos may not have been processed for tagging.`,
  },
  [FilterValues.Tagged]: {
    heading: msg`No tagged people`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/khsnqnp7k75jmt9qpvf2zhv/ghosts.svg?auto=webp&format=svg',
    subheading: msg`People who have been tagged with a name will appear here.`,
  },
  [FilterValues.Untagged]: {
    heading: msg`No untagged people`,
    imgSrc: 'https://cdn.bfldr.com/27C9EC93/at/9gnrpsj4mjskfh875j5jb5v/checks.svg?auto=webp&format=svg',
    subheading: msg`You’ve identified everyone in this ${libraryTitle}’s photos.`,
  }
};
